import { render } from "./EditImage.vue?vue&type=template&id=1aa35256"
import script from "./EditImage.vue?vue&type=script&lang=js"
export * from "./EditImage.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__